import { render, staticRenderFns } from "./baiguullaga_ajiliin_bairni_zar.vue?vue&type=template&id=d13b8c42&scoped=true&"
import script from "./baiguullaga_ajiliin_bairni_zar.vue?vue&type=script&lang=js&"
export * from "./baiguullaga_ajiliin_bairni_zar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13b8c42",
  null
  
)

export default component.exports